import styled, { css } from 'styled-components';

import { COLORS, SCREEN_SIZE } from '@components/web/src/styles';

export const TastingTip = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 20px;
  width: 100%;
  border-radius: 16px;
  background-color: ${COLORS.gray[800]};

  img {
    ${({ theme }) =>
      theme?.isKioskRootElementType
        ? css`
            width: 50px;
            height: 50px;
          `
        : css`
            width: 40px;
            height: 40px;
            @container rootContainer (min-width: ${SCREEN_SIZE.TABLET_WIDTH}) {
              width: 50px;
              height: 50px;
            }
          `}
  }
`;
